var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M4 8h24M25.334 8v18.666c0 1.474-1.195 2.668-2.668 2.668v0h-13.332c-1.473 0-2.668-1.195-2.668-2.668v0-18.666M10.666 8v-2.666c0-0.001 0-0.001 0-0.002 0-1.472 1.194-2.666 2.666-2.666 0.001 0 0.001 0 0.002 0h5.332c0.001 0 0.001 0 0.002 0 1.472 0 2.666 1.194 2.666 2.666 0 0.001 0 0.001 0 0.002v-0 2.666M13.334 14.666v8M18.666 14.666v8"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-out",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    d: "M21.333 22.667 28 16m0 0-6.667-6.667M28 16H12m0-12h-1.6c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 7.04 4 8.16 4 10.4v11.2c0 2.24 0 3.36.436 4.216a3.996 3.996 0 0 0 1.748 1.748C7.04 28 8.16 28 10.4 28H12"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "m20 24-8-8 8-8"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "m12 24 8-8-8-8"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M24 8 8 24M8 8l16 16"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M21.333 24 24 26.667l5.333-5.333M16 20.667h-6c-1.861 0-2.791 0-3.548.23a5.331 5.331 0 0 0-3.555 3.556c-.23.757-.23 1.687-.23 3.548M13.333 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M28 13.333H4m24 3.334v-4.933c0-2.24 0-3.36-.436-4.216a3.991 3.991 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 8.374 4 9.494 4 11.734v11.2c0 2.24 0 3.36.436 4.216a3.991 3.991 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.333-26.667V8M10.667 2.667V8m8.666 17.333L22 28l6-6"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-chart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 9.037c0-.759.001-1.305.038-1.732.037-.436.103-.596.134-.648a.058.058 0 0 1 .015-.019h.001c.009-.006.045-.031.138-.06.208-.064.569-.112 1.207-.112s1 .048 1.207.112a.467.467 0 0 1 .138.06h.001c.004.003.007.005.015.019.031.052.097.212.134.648.037.427.037.973.037 1.732v13.926c0 .896-.051 1.503-.135 1.915-.084.414-.182.531-.199.548a.09.09 0 0 1-.029.02.68.68 0 0 1-.169.046c-.221.038-.511.041-1.002.041-.499 0-.793-.003-1.015-.042a.719.719 0 0 1-.168-.045c-.016-.008-.02-.012-.025-.017-.015-.016-.112-.131-.195-.547-.082-.413-.132-1.022-.132-1.92V9.036zM25.333 4.2c-1.288 0-2.612.136-3.305 1.291-.302.504-.403 1.084-.449 1.621-.046.535-.046 1.177-.046 1.884v13.968c0 .954.05 1.734.175 2.363.125.625.343 1.205.761 1.652.439.47.975.664 1.466.748.435.074.92.074 1.344.074h.107c.418 0 .9 0 1.333-.074.489-.084 1.023-.278 1.463-.745.42-.445.643-1.023.77-1.651.128-.63.18-1.412.18-2.367V8.996c0-.706 0-1.349-.046-1.884-.046-.536-.147-1.117-.449-1.621C27.944 4.336 26.62 4.2 25.332 4.2zm-10.828 8.467c-.033.301-.035.651-.035 1.111v9.811c-.033 1.146.175 1.533.299 1.666.107.115.376.279 1.23.279.834 0 1.112-.162 1.226-.283.127-.134.34-.523.303-1.658l-.001-.036v-9.778c0-.461-.001-.811-.035-1.111-.033-.296-.089-.448-.137-.529l-.002-.003c-.031-.053-.198-.335-1.356-.335s-1.324.282-1.356.335l-.002.003c-.049.081-.104.232-.137.529zm-1.807-1.694c.639-1.066 1.819-1.44 3.302-1.44s2.663.374 3.302 1.44c.284.475.395.99.445 1.444.049.438.049.908.049 1.328v9.793c.039 1.301-.16 2.461-.921 3.267-.777.823-1.869.995-2.875.995-1.015 0-2.112-.169-2.887-.999-.754-.808-.944-1.97-.909-3.261v-9.795c0-.42 0-.89.049-1.328.05-.454.161-.969.445-1.444zm-7.529 8.386c-.035.352-.036.776-.036 1.344v3.689c0 .641.155.816.23.879.122.103.453.261 1.303.261.832 0 1.167-.156 1.296-.264.081-.068.237-.247.237-.877v-3.669l-.009-.27c-.015-.439-.026-.782-.059-1.085-.039-.363-.099-.533-.146-.615l-.001-.002c-.012-.027-.127-.285-1.319-.285-1.196 0-1.336.261-1.355.297l-.001.003c-.046.078-.106.242-.141.593zm-1.813-1.741c.654-1.112 1.877-1.418 3.31-1.418 1.436 0 2.648.307 3.288 1.431.276.485.379 1.02.43 1.495.043.395.057.841.072 1.281l.009.257v3.729c0 .991-.256 1.949-1.047 2.613-.744.624-1.741.795-2.753.795-1.021 0-2.024-.169-2.767-.798-.79-.669-1.033-1.63-1.033-2.61v-3.725c0-.522 0-1.056.047-1.532.048-.487.155-1.029.442-1.517z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down-arrow-right",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.936 14.79 1.203.818-22.877.001v.64l22.733-.001-1.133.651.319.555 2.608-1.498-2.493-1.695-.36.529z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down-arrow-left",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.966 17.067-1.203-.818 22.877-.001v-.64l-22.733.001 1.133-.651-.319-.555-2.608 1.498 2.493 1.695.36-.529z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-in",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.526,
    d: "M19.789 4.632h1.516c2.122 0 3.183 0 3.994.413a3.786 3.786 0 0 1 1.656 1.656c.413.811.413 1.872.413 3.994v10.611c0 2.122 0 3.183-.413 3.994a3.786 3.786 0 0 1-1.656 1.656c-.811.413-1.872.413-3.994.413h-1.516M13.474 9.684 19.79 16m-.001 0-6.316 6.316M19.789 16H4.631"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 10.667v10.667M10.667 16h10.667m7.999 0c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16C2.667 8.636 8.637 2.667 16 2.667S29.333 8.637 29.333 16z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-box",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M12 4h8M4 8h24M6.667 8l.801 12.018c.149 2.231.223 3.347.588 4.243a6 6 0 0 0 3.672 3.435c.919.304 2.037.304 4.273.304 2.236 0 3.354 0 4.273-.304a5.999 5.999 0 0 0 3.671-3.435c.365-.896.439-2.012.588-4.243L25.334 8"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "m3.333 28.667 7.399-2.846c.473-.182.71-.273.931-.392.197-.106.384-.227.56-.364.198-.154.378-.333.736-.692l15.04-15.04A3.77 3.77 0 1 0 22.666 4L7.626 19.04c-.359.359-.538.538-.692.736a3.902 3.902 0 0 0-.364.561c-.119.221-.21.458-.392.931l-2.846 7.399zm0 0 2.744-7.135c.196-.511.295-.766.463-.883a.665.665 0 0 1 .505-.107c.201.038.395.232.782.619l3.012 3.012c.387.387.58.58.619.782a.665.665 0 0 1-.107.505c-.117.168-.372.267-.883.463l-7.135 2.744z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-icon-exit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M4.451 9.333a13.328 13.328 0 0 1 11.55-6.667c7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333a13.329 13.329 0 0 1-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M16 21.333 21.333 16 16 10.667M2.667 16h18.667"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676S19.681 9.324 16 9.324 9.324 12.319 9.324 16zM16 11.991c2.211 0 4.009 1.799 4.009 4.009S18.21 20.009 16 20.009c-2.211 0-4.009-1.799-4.009-4.009S13.79 11.991 16 11.991zm-1.336 13.342h2.667v4h-2.667v-4zm0-22.666h2.667v4h-2.667v-4zm-12 12h4v2.667h-4v-2.667zm22.667 0h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345 5.627 7.516l1.887-1.885 2.827 2.829-1.884 1.885zm17.912 14.14-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.656 17.393c-.904.24-1.834.361-2.769.361-2.847 0-5.52-1.107-7.528-3.115a10.702 10.702 0 0 1-2.751-10.298 1.33 1.33 0 0 0-.943-1.63 1.345 1.345 0 0 0-.69 0A13.346 13.346 0 0 0 6.99 6.154c-5.197 5.197-5.197 13.657 0 18.857a13.26 13.26 0 0 0 9.429 3.907 13.245 13.245 0 0 0 9.427-3.905 13.343 13.343 0 0 0 3.444-5.988 1.33 1.33 0 0 0-.347-1.285 1.34 1.34 0 0 0-1.285-.346zm-3.696 5.735a10.594 10.594 0 0 1-7.542 3.124 10.585 10.585 0 0 1-7.544-3.125c-4.157-4.159-4.157-10.927 0-15.085a10.562 10.562 0 0 1 2.747-1.977 13.365 13.365 0 0 0 3.854 10.464 13.29 13.29 0 0 0 10.464 3.854 10.704 10.704 0 0 1-1.979 2.745z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M28 13.333H4m24 3.334v-4.933c0-2.24 0-3.36-.436-4.216a3.991 3.991 0 0 0-1.748-1.748c-.856-.436-1.976-.436-4.216-.436H10.4c-2.24 0-3.36 0-4.216.436a3.991 3.991 0 0 0-1.748 1.748C4 8.374 4 9.494 4 11.734v11.2c0 2.24 0 3.36.436 4.216a3.991 3.991 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436H16m5.333-26.667V8M10.667 2.667V8m8.666 17.333L22 28l6-6"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M21.333 24 24 26.667l5.333-5.333M16 20.667h-6c-1.861 0-2.791 0-3.548.23a5.331 5.331 0 0 0-3.555 3.556c-.23.757-.23 1.687-.23 3.548M13.333 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-done-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.133 18.4l-2.9-2.9c-0.215-0.217-0.513-0.352-0.843-0.352-0.026 0-0.051 0.001-0.076 0.002l0.003-0c-0.359 0.001-0.683 0.147-0.917 0.383l-0 0c-0.227 0.228-0.367 0.543-0.367 0.891 0 0.015 0 0.030 0.001 0.045l-0-0.002c0 0.377 0.123 0.689 0.367 0.933l3.8 3.8c0.228 0.227 0.543 0.367 0.891 0.367 0.015 0 0.030-0 0.045-0.001l-0.002 0c0.013 0 0.027 0.001 0.042 0.001 0.348 0 0.662-0.14 0.891-0.367l7.567-7.567c0.218-0.216 0.353-0.516 0.353-0.847 0-0.025-0.001-0.050-0.002-0.074l0 0.003c-0.002-0.358-0.149-0.682-0.384-0.916l-0-0c-0.228-0.227-0.543-0.367-0.891-0.367-0.015 0-0.030 0-0.045 0.001l0.002-0c-0.013-0-0.027-0.001-0.042-0.001-0.348 0-0.663 0.14-0.891 0.367l-6.6 6.6zM16 29.333c-0.025 0-0.055 0-0.084 0-1.849 0-3.607-0.387-5.199-1.084l0.083 0.033c-1.644-0.709-3.048-1.669-4.234-2.85l0 0c-1.2-1.2-2.149-2.611-2.849-4.233-0.664-1.508-1.051-3.267-1.051-5.116 0-0.030 0-0.059 0-0.089l-0 0.005c0-1.844 0.351-3.577 1.051-5.2 0.709-1.644 1.669-3.048 2.85-4.234l-0 0c1.2-1.2 2.611-2.151 4.233-2.851 1.508-0.663 3.267-1.050 5.116-1.050 0.030 0 0.059 0 0.089 0l-0.005-0c1.844 0 3.577 0.349 5.2 1.049 1.644 0.709 3.048 1.671 4.234 2.851l-0-0c1.2 1.2 2.149 2.611 2.849 4.233 0.664 1.508 1.051 3.267 1.051 5.116 0 0.030-0 0.059-0 0.089l0-0.005c0 0.025 0 0.055 0 0.084 0 1.849-0.387 3.608-1.084 5.199l0.033-0.083c-0.709 1.644-1.669 3.048-2.85 4.234l0-0c-1.2 1.2-2.611 2.149-4.233 2.849-1.508 0.664-3.267 1.051-5.116 1.051-0.030 0-0.059-0-0.089-0l0.005 0zM16 26.667c2.956 0 5.472-1.039 7.551-3.116 2.077-2.079 3.116-4.595 3.116-7.551s-1.039-5.472-3.116-7.551c-2.079-2.077-4.595-3.116-7.551-3.116s-5.472 1.039-7.549 3.116c-2.079 2.079-3.117 4.595-3.117 7.551s1.040 5.472 3.117 7.551c2.077 2.077 4.593 3.116 7.549 3.116z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 24h24"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 20h2.667v2.667h-2.667v-2.667zM14.667 9.333h2.667v8h-2.667v-8zM15.987 2.667c-7.36 0-13.32 5.973-13.32 13.333s5.96 13.333 13.32 13.333c7.373 0 13.347-5.973 13.347-13.333s-5.973-13.333-13.347-13.333zM16 26.667c-5.893 0-10.667-4.773-10.667-10.667s4.773-10.667 10.667-10.667 10.667 4.773 10.667 10.667-4.773 10.667-10.667 10.667z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M20 8l-8 8 8 8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    style: {
      fill: "var(--color1, #ffc107)"
    },
    d: "M29.074 13.389h-1.074v-0.055h-12v5.333h7.535c-1.099 3.105-4.053 5.333-7.535 5.333-4.418 0-8-3.582-8-8s3.582-8 8-8c2.039 0 3.895 0.769 5.307 2.026l3.771-3.771c-2.381-2.219-5.567-3.588-9.079-3.588-7.363 0-13.333 5.97-13.333 13.333s5.97 13.333 13.333 13.333c7.363 0 13.333-5.97 13.333-13.333 0-0.894-0.092-1.767-0.259-2.611z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    style: {
      fill: "var(--color2, #ff3d00)"
    },
    d: "M4.204 9.794l4.381 3.213c1.185-2.935 4.056-5.007 7.415-5.007 2.039 0 3.895 0.769 5.307 2.026l3.771-3.771c-2.381-2.219-5.567-3.588-9.079-3.588-5.121 0-9.563 2.891-11.796 7.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    style: {
      fill: "var(--color3, #4caf50)"
    },
    d: "M16 29.333c3.444 0 6.573-1.318 8.939-3.461l-4.127-3.492c-1.339 1.014-3.003 1.62-4.813 1.62-3.468 0-6.413-2.211-7.522-5.297l-4.348 3.35c2.207 4.318 6.688 7.281 11.87 7.281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    style: {
      fill: "var(--color4, #1976d2)"
    },
    d: "M29.074 13.389h-1.074v-0.055h-12v5.333h7.535c-0.528 1.491-1.487 2.777-2.725 3.714 0.001-0.001 0.001-0.001 0.002-0.001l4.127 3.492c-0.292 0.265 4.394-3.205 4.394-9.871 0-0.894-0.092-1.767-0.259-2.611z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-united-kingdom",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    style: {
      fill: "var(--color1, #f0f0f0)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M3.308 6.259c-1.257 1.635-2.204 3.52-2.756 5.567h8.324l-5.567-5.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M31.449 11.826c-0.552-2.047-1.5-3.932-2.756-5.567l-5.567 5.567h8.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M0.551 20.174c0.552 2.047 1.5 3.932 2.756 5.567l5.567-5.567h-8.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M25.741 3.308c-1.635-1.257-3.52-2.204-5.567-2.756v8.324l5.567-5.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M6.259 28.692c1.635 1.257 3.52 2.204 5.567 2.756v-8.323l-5.567 5.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M11.826 0.551c-2.047 0.552-3.932 1.5-5.567 2.756l5.567 5.567v-8.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M20.174 31.449c2.047-0.552 3.932-1.5 5.567-2.756l-5.567-5.567v8.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    style: {
      fill: "var(--color2, #0052b4)"
    },
    d: "M23.125 20.174l5.567 5.567c1.257-1.635 2.204-3.52 2.756-5.567h-8.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color3, #d80027)"
    },
    d: "M31.865 13.913h-13.778v-13.778c-0.683-0.089-1.38-0.135-2.087-0.135s-1.404 0.046-2.087 0.135v13.778h-13.778c-0.089 0.683-0.135 1.38-0.135 2.087s0.046 1.404 0.135 2.087h13.778v13.778c0.683 0.089 1.38 0.135 2.087 0.135s1.404-0.046 2.087-0.135v-13.778h13.778c0.089-0.683 0.135-1.38 0.135-2.087s-0.047-1.404-0.135-2.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color3, #d80027)"
    },
    d: "M20.174 20.174v0l7.14 7.14c0.328-0.328 0.642-0.671 0.941-1.027l-6.113-6.113-1.968 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color3, #d80027)"
    },
    d: "M11.826 20.174h-0l-7.14 7.14c0.328 0.328 0.671 0.642 1.027 0.941l6.113-6.113v-1.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color3, #d80027)"
    },
    d: "M11.826 11.826v-0l-7.14-7.14c-0.328 0.328-0.642 0.671-0.941 1.027l6.113 6.113h1.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    style: {
      fill: "var(--color3, #d80027)"
    },
    d: "M20.174 11.826v0l7.14-7.14c-0.328-0.328-0.671-0.642-1.027-0.94l-6.113 6.113v1.968z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ukraine",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    style: {
      fill: "var(--color4, #ffda44)"
    },
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338af3",
    style: {
      fill: "var(--color5, #338af3)"
    },
    d: "M0 16c0-8.836 7.163-16 16-16s16 7.163 16 16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.05b55364b33d18c05903e80a1a089bd2.svg";
export { ForwardRef as ReactComponent };